var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardBlack24Dp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-3.667-3.667h29.334v29.334H-3.667z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.556 2.444V4.89h-4.89V2.444h4.89m-12.223 0v7.334H2.444V2.444h4.89m12.222 9.778v7.334h-4.89v-7.334h4.89m-12.223 4.89v2.444H2.444V17.11h4.89M22 0h-9.778v7.333H22V0zM9.778 0H0v12.222h9.778V0zM22 9.778h-9.778V22H22V9.778zM9.778 14.667H0V22h9.778v-7.333z",
    fill: "#232323",
    fillRule: "nonzero"
  }))));
}
export default SvgDashboardBlack24Dp;